module.exports = __webpack_public_path__ + "static/img/n9m1.c45708c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/n9m/n9m1.jpg
// module id = 5x3t
// module chunks = 1